import BaseService from '../services/BaseService';

export const apiErrorMessage = (error, fallback) =>
  error?.response?.data?.message || fallback;

const asList = (data) => (Array.isArray(data) ? data : []);

export async function fetchMyOptionCodes() {
  try {
    const response = await BaseService.get({ url: 'options/permissions/me' });
    return asList(response.data)
      .map((item) => item?.codigo)
      .filter(Boolean);
  } catch (error) {
    const status = error?.response?.status;
    if (status === 403 || status === 404) return [];
    throw error;
  }
}

export async function fetchOptionValues(codigo) {
  const response = await BaseService.get({
    url: `options/gestao/${codigo}?incluirInativos=true`,
  });
  return asList(response.data);
}

export async function createOption(payload) {
  const response = await BaseService.post({ url: 'options/gestao', data: payload });
  return response.data;
}

export async function updateOption(id, payload) {
  const response = await BaseService.put({ url: `options/gestao/${id}`, data: payload });
  return response.data;
}

export async function setOptionAtivo(id, codigo, ativo) {
  const response = await BaseService.patch({
    url: `options/gestao/${id}/ativo?codigo=${encodeURIComponent(codigo)}&ativo=${ativo}`,
    data: {},
  });
  return response.data;
}

export async function listOptionPermissions(userId) {
  const response = await BaseService.get({ url: `options/permissions/${userId}` });
  return asList(response.data);
}

export async function grantOptionPermission(userId, codigo) {
  const response = await BaseService.post({
    url: 'options/permissions',
    data: { userId, codigo },
  });
  return response.data;
}

export async function revokeOptionPermission(userId, codigo) {
  await BaseService.delete({
    url: 'options/permissions',
    data: { userId, codigo },
  });
}
